import { object, string, ref } from "yup";

export const getValidation = () => {
  const validationSchema = object().shape({
    password: string()
      .required()
      .min(8)
      .default(""),
    confirm: string()
      .oneOf(
        [ref("password"), null],
        "Password doesn't match Confirm Password."
      )
      .default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};
